import React from 'react';
import DocumentTitle from 'react-document-title';
import { errorMessage, customMessage } from 'actions/internal';
import TopNavBar from 'containers/nav/TopNavBar';
import SubNavBar from 'containers/nav/SubNavBar';
import AdministrationSubNav from 'components/administration/AdministrationSubNav';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { appNamedRoutes } from 'routes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import { authHeaders } from 'actions';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AccountInputs from './AccountInputs';
import { useForm, FormProvider } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';

const AdministrationFamiliesNewPage = ({
  auth,
  history,
  onErrorMessage,
  onCustomMessage,
}) => {
  const queryClient = useQueryClient();
  const formMethods = useForm({
    mode: 'onChange',
    defaultValues: {
      partner_id: auth.partnerId,
      players_attributes: [],
    },
  })

  const createAccount = useMutation({
    mutationKey: ['administration', 'accounts', 'save'],
    mutationFn: (account) => {
      return axios.post(Routes.api_dashboard_administration_accounts_path(),
        { account: account }, { headers: authHeaders() })
    },
    onSuccess: () => {
      onCustomMessage('Account created successfully', 'success');
      queryClient.invalidateQueries({ queryKey:['administraiton', 'accounts']});
      history.push(`${appNamedRoutes.administrationFamilies}${history.location.search}`);
    },
    onError: (error) => {
      if (error.response.status === 500) {
        onErrorMessage('Oops! Something went wrong. Contact support for help.');
        return
      }

      if (error.response.status === 422) {
        onErrorMessage('Please check the form for errors and try again.');
        const account = error.response.data;
        const players = account.players || [];

        Object.entries(account.errors).forEach(([field, errors]) => {
          if (!field.includes('.')) {
            formMethods.setError(field, { type: 'manual', message: errors.join(', ') })
          }
        });

        players.forEach((player, index) => {
          Object.entries(player.errors).forEach(([field, errors]) => {
            formMethods.setError(`players_attributes[${index}].${field}`, { type: 'manual', message: errors.join(', ') })
          });
        })

        return
      }
    },
  })

  const filtersQuery = useQuery({
    queryKey: ['administration', 'filters'],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_filters_path(),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
    onError: (error) => {
      onErrorMessage(error.response.data.message);
    },
  })

  const onSubmit = async (data) => {
    createAccount.mutate(data);
  };

  return (<DocumentTitle title='Sparkler - Administration'>
    <div>
      <TopNavBar />
      <SubNavBar />
      <AdministrationSubNav />
      <div className="row">
        <div className="column">
          <div className='u-margin-top--base u-margin-bottom--large'>
            <span className='o-sp-button o-sp-button--back' onClick={() => {
              const queryParams = history.location.search;
              history.push(`${appNamedRoutes.administrationFamilies}${queryParams}`)
            }}>
              <i className='sp-icon-arrow-left'></i>&nbsp;Back
            </span>
          </div>
          <div className="row u-margin-top--base">
            <div className="column">
              <FormProvider {...formMethods}>
                <form onSubmit={(event) => {
                  formMethods.clearErrors();
                  formMethods.handleSubmit(onSubmit)(event);
                }}>
                  <AccountInputs
                    auth={auth}
                    cohorts={filtersQuery.data?.cohorts || []}
                  />
                </form>
              </FormProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DocumentTitle>
  );
}

AdministrationFamiliesNewPage.propTypes = {
  history: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
  onErrorMessage: PropTypes.func.isRequired,
  onCustomMessage: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onErrorMessage: (message) => {
      dispatch(errorMessage(message))
    },
    onCustomMessage: (message, type) => {
      dispatch(customMessage(message, type))
    },
    onShowLoading: () => {
      dispatch(showLoading())
    },
    onHideLoading: () => {
      dispatch(hideLoading())
    },
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(AdministrationFamiliesNewPage);
